<template>
    <div class="text-center mt-6 px-9">
        <button type="button"
            class="outline-none appearance-none w-full text-15 ff-semi mx-auto text-center"
            @click="onClickLogin">
            <!-- {{ lbl.login.btnLogin }} -->
            <img src="@/module/TheOne/assets/buttons/btn-signin.png" class="h-12 mx-auto" />
        </button>
    </div>
</template>
<script>
import { inject } from 'vue';

export default {
    name: 'BtnLogin',
    emits: ["onClickLogin"],
    setup: function () {
        const { lbl } = inject("LocaleStore")

        return {
            lbl
        }
    },
    methods: {
        onClickLogin: function () {
            this.$emit("onClickLogin")
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-custom {
    max-width: 344px;
}
</style>
